export default {
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: null,
    },
    caption: {
      type: String,
      required: false,
    },
    prefix: {
      type: String,
      required: false,
    },
    suffix: {
      type: String,
      required: false,
    },
    suffixLength: {
      type: Number,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    icon: {
      validator(value) {
        if (value && value.render) {
          return true;
        }

        console.error('Invalid icon prop', value);
        return false;
      },
    },
  },
};
